var map = {
	"./pegi-3.png": "4399",
	"./pegi-en.png": "d719",
	"./pegi-es.png": "f27d",
	"./pegi-fr.png": "a88a",
	"./pegi-it.png": "b2d1",
	"./pegi-pt.png": "7aa1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f31a";